import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import PayrollPaywallGuard from 'modules/payroll_bundle/pages/PayrollPaywallGuard'
import A3innuvaIntegrationLinkStatus from 'modules/payroll_integrations_a3innuva/components/IntegrationLinkStatus'

const Settings = () => {
  return (
    <PayrollPaywallGuard>
      <ResponsivePage.Body>
        <A3innuvaIntegrationLinkStatus />
      </ResponsivePage.Body>
    </PayrollPaywallGuard>
  )
}

export default Settings
